import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms'; //2018-03-05   李红强     增加  修改页面布局显示
import {RouterModule} from '@angular/router';
import {PsI18nModule} from '../../../pf.core/i18n/psi18n.module';
import {BigBreadcrumbsComponent} from './big-breadcrumbs.component';
import {MinifyMenuComponent} from './minify-menu.component';
import {NavigationComponent} from './navigation.component';
import {SmartMenuDirective} from './smart-menu.directive';
import {UserModule} from '../../user/user.module';
// import {ChatModule} from '../../chat/chat.module';
import { ModalModule } from 'ngx-bootstrap'
import {LayoutSwitcherComponent} from '../layout-switcher.component'; //2018-03-05   李红强     增加  修改页面布局显示
import {NavigationCountService} from './navigation-count-service'
import { ExtendedRouterLinkWithHrefDirective } from './extended-routerlinkwithhref-directive'
import { ExtendedRouterLinkActiveDirective } from './extended-routerlinkactive-directive' ;
import {SmartadminWidgetsModule} from '../../widgets/smartadmin-widgets.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PsI18nModule,
    UserModule,
    ModalModule,
    FormsModule,//2018-03-05   李红强     增加  修改页面布局显示
    SmartadminWidgetsModule
    // ChatModule
  ],
  declarations: [
    BigBreadcrumbsComponent,
    MinifyMenuComponent,
    NavigationComponent,
    SmartMenuDirective,
    ExtendedRouterLinkActiveDirective,     // このモジュール内部用   
    ExtendedRouterLinkWithHrefDirective,   // このモジュール内部用 
    LayoutSwitcherComponent,  //2018-03-05   李红强     增加  修改页面布局显示
  ],
  exports: [
    BigBreadcrumbsComponent,
    MinifyMenuComponent,
    NavigationComponent,
    SmartMenuDirective,
    LayoutSwitcherComponent,//2018-03-05   李红强     增加  修改页面布局显示
  ], 
  providers: [ NavigationCountService ]
})
export class NavigationModule{}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/navigation/navigation.module.ts